import React from 'react';
import styled from 'styled-components';

const StyledSeparator = styled.span`
  ::after {
    content: ' ';
  }
  ::before {
    content: ' ';
  }
`;

function Separator() {
  return <StyledSeparator>·</StyledSeparator>;
}

export default Separator;
